/**
 * Initialise sal.js
 *
 * @see https://github.com/mciastek/sal
 * @see https://inorganik.github.io/countUp.js
 */

import Sal from '../vendor/sal.js'

/* initialise Sal if the browser supports it */
if('IntersectionObserver' in window){
    const scrollAnimations = new Sal({
        threshold: 0.05,
        once: true,
    });
} else {
    document.body.classList.add("sal-disabled");
}

/* debugging
const element = document.querySelector('.js-sal');

element.addEventListener('sal:in', ({ detail }) => {
    console.log('entering', detail.target);
});

element.addEventListener('sal:out', ({ detail }) => {
    console.log('leaving', detail.target);
});
*/